import { IconWorld } from "@tabler/icons-react"
import { type ReactNode } from "react"

import SelectedStatus from "./SelectedStatus"

const DomainHeading = ({
	domain,
	subdomain,
	isSelected,
	description,
	status,
}: {
	domain: string
	subdomain: string
	isSelected: boolean
	description: string
	status?: ReactNode
}) => (
	<div className="flex min-w-0 items-start gap-3">
		<span className="bg-component-background text-primary flex size-10 shrink-0 items-center justify-center rounded-xl">
			<IconWorld size={21} stroke={1.6} aria-hidden="true" />
		</span>
		<div className="min-w-0 flex-1">
			<div className="flex flex-wrap items-center gap-2">
				<h2 className="text-base font-semibold break-all">{domain}</h2>
				{status ?? <SelectedStatus isSelected={isSelected} />}
			</div>
			<p className="mt-1 text-xs text-gray-500">{description}</p>
			<p className="mt-3 text-sm break-all text-gray-600">
				<span className="text-gray-400">Academy address · </span>
				{subdomain}.{domain}
			</p>
		</div>
	</div>
)

export default DomainHeading
